import React from "react";
import { useNavigate } from "react-router-dom";

import "./styles.sass";

const BackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="back-button" onClick={handleGoBack}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <path
          fill="currentColor"
          d="M15.4 18.3L8.7 12l6.7-6.3L14 4.7l-8 7.5 8 7.6z"
        />
      </svg>
    </div>
  );
};

export default BackButton;
